import { useEffect, useState } from "react";

const cache = new Map<string, Element | null>();

export function useServerSideContent(selector: string) {
  const [element, setElement] = useState<Element | null>(null);
  const [loaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!cache.has(selector)) {
      cache.set(selector, document.querySelector(selector));
    }
    setElement(cache.get(selector) as Element | null);
    setIsLoaded(true);
  }, [selector]);

  return { element, loaded };
}
